<template>
  <div v-if="response.length">
    <b-card>
      <b-form-row>
        <b-col cols="12">
          <b-table striped hover :items="items">
            <template v-slot:cell(label)="data">
              <b-link v-bind:href="'#/rfqs/' + response[data.index].id">{{data.value}}</b-link>
            </template>
          </b-table>
        </b-col>
      </b-form-row>
      <b-form-row v-if="hasMore">
        <b-col cols="12">
          <b-button block variant="primary" v-on:click="$emit('loadMore')">Load More</b-button>
        </b-col>
      </b-form-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "rfqs-results",
  props: ["response", "hasMore"],
  computed: {
    items: function() {
      return this.response?.map(rfq_summary => ({
        label: rfq_summary.label,
        sent: rfq_summary.sentTs ? rfq_summary.sentTs.toLocaleDateString() : "",
        return_by: rfq_summary.returnByTs ? rfq_summary.returnByTs.toLocaleDateString() : "",
        received: rfq_summary.receivedTs ? rfq_summary.receivedTs.toLocaleDateString() : "(waiting)",
        cage_code: rfq_summary.receivingCageCode ? rfq_summary.receivingCageCode : "N/A",
        opportunities: rfq_summary.opportunities
          .map(opportunity => opportunity.label)
          .join(", "),
        _rowVariant: rfq_summary.receivedTs ? null : 
          (rfq_summary.opportunities
            .filter(x => x.isActive).length ? "danger" : "warning")
      }));
    }
  }
};
</script>